"use client";
import React from "react";
import TopContent from "./TopContent";
import SharedLinksWithDate from "@/components/SharedLinksWithDate";

const BlogSingleCard = ({ data, readMoreLabel }) => {
  return (
    <div className="flex flex-col gap-[16px] max-w-[334px] mx-auto md:max-w-none sm:justify-between">
      <TopContent data={data} readMoreLabel={readMoreLabel} />
      <SharedLinksWithDate
        date={data?.data?.post_date}
        url={`/blogs/${data?.uid}`}
      />
    </div>
  );
};

export default BlogSingleCard;
